<template>
  <LoadingIndicator
    v-if="loadingData"
    class="mt-5"
  />

  <PageWrap v-else :page-title="pageTitle">
    <b-row>
      <b-col md="10" lg="8">
        <BranchForm
          :data="formData"
          :editing="isEditing"
          :errors="formErrors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
    <BfButton v-if="!isEditing" @click="createBranch">Guardar</BfButton>
    <BfButton
      v-if="isEditing"
      variant="red"
      @click="showDeleteModal"
    >
      Eliminar
    </BfButton>

    <DeleteWarningModal
      v-model="displayDeleteModal"
      title="¿Desea eliminar esta sucursal?"
      @confirm-deletion="deleteBranch"
    />
  </PageWrap>
</template>

<script>
import PageWrap from '@/components/PageWrap';
import BranchForm from '@/components/FormGroups/BranchForm';
import LoadingIndicator from '@/components/LoadingIndicator';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import { branchAPI } from '@/api';


export default {
  name: 'BranchesDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: [branchData],
      } = await branchAPI.get(this.id);

      this.formData = branchData;
    },

    async prepareForm() {
      const { data } = await branchAPI.preCreate();

      this.formData = data;
    },

    async createBranch() {
      try {
        this.formErrors = {};
        const { data, message } = await branchAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({
          name: 'branch',
          params: { id: `${data.id}` },
        });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        });
      }
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await branchAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true;
    },
    async deleteBranch() {
      try {
        const { message } = await branchAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'branches' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Sucursal ${this.formData.sucursal}` : 'Crear Sucursal';
    },
  },

  components: {
    BranchForm,
    DeleteWarningModal,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
